import { render, staticRenderFns } from "./6Step.vue?vue&type=template&id=39aff346&scoped=true&"
import script from "./6Step.vue?vue&type=script&lang=js&"
export * from "./6Step.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39aff346",
  null
  
)

export default component.exports